export const all_routes = {
  // ==========================================
  // ROTAS ATIVAS (usadas pelo CRM)
  // ==========================================

  // dashboard
  leadsDashboard: "/leads-dashboard",
  dashboardTnp: "/dashboard-tnp",
  dashboardCliente: "/dashboard",

  // application
  chat: "/chat",
  mobileApp: "/mobile-app",
  mobileAppLogin: "/mobile-app/login",
  connections: "/conexoes",
  todo: "/todo",
  todoAdmin: "/todo-admin",
  kanbanView: "/kanban-view",
  kanbanViewPipeline: "/kanban-view-pipeline",
  cardBuilder: "/card-builder",
  cardBuilderAdmin: "/card-builder-admin",
  teamUserManagement: "/team-user-management",
  adminChats: "/admin-chats",
  whatsappTemplates: "/whatsapp-templates",
  templatesComErro: "/templates-com-erro",
  leadsType: "/leads-type",
  discadora: "/discadora",
  bibliotecaMidias: "/biblioteca-midias",
  respostasRapidas: "/respostas-rapidas",

  // pages
  error404: "/error-404",
  error500: "/error-500",
  limparCache: "/limpar-cache",
  // Multi-conta: shell que roda cada conta num frame isolado (ver MultiConta.tsx)
  multiConta: "/contas",

  // auth
  login3: "/entrar",
  adminlogin: "/entrar-admin",
  wladmin: "/wl-admin",
  register3: "/cadastro",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPasswordSuccess: "/success",

  // crm
  leadsList: "/leads-list",
  leadsGrid: "/leads-grid",
  leadsDetails: "/leads-details",
  agendamento: "/agendamento",
  pagamento: "/pagamento",
  pipelineList: "/pipeline-list",
  pipeline: "/pipeline",
  analytics: "/analytics",
  contactGrid: "/contact-grid",
  contactList: "/contact-list",
  contactDetails: "/contact-details",
  companiesGrid: "/companies-grid",
  companiesList: "/companies-list",
  companiesDetails: "/companies-details",
  dealsGrid: "/deals-grid",
  dealsList: "/deals-list",
  dealsDetails: "/deals-details",

  // ==========================================
  // PLACEHOLDERS (referenciados por componentes de template, sem rota ativa)
  // ==========================================

  // dashboards (template)
  adminDashboard: "#",
  employeeDashboard: "#",
  dealsDashboard: "#",

  // application (template)
  voiceCall: "#",
  videoCall: "#",
  outgoingCall: "#",
  incomingCall: "#",
  callHistory: "#",
  TodoList: "#",
  email: "#",
  EmailReply: "#",
  audioCall: "#",
  fileManager: "#",
  socialFeed: "#",
  invoice: "#",
  notes: "#",
  calendar: "#",
  dataTables: "#",
  tablesBasic: "#",

  // super admin (template)
  superAdminDashboard: "#",
  superAdminCompanies: "#",
  superAdminSubscriptions: "#",
  superAdminPackages: "#",
  superAdminPackagesGrid: "#",
  superAdminDomain: "#",
  superAdminPurchaseTransaction: "#",

  // pages (template)
  starter: "#",
  profile: "#",
  gallery: "#",
  searchresult: "#",
  timeline: "#",
  pricing: "#",
  comingSoon: "#",
  underMaintenance: "#",
  underConstruction: "#",
  apikey: "#",
  privacyPolicy: "#",
  termscondition: "#",
  pages: "#",

  // auth variants (template)
  login: "#",
  login2: "#",
  register: "#",
  register2: "#",
  forgotPassword2: "#",
  forgotPassword3: "#",
  twoStepVerification2: "#",
  twoStepVerification3: "#",
  success: "#",
  emailVerification2: "#",
  emailVerification3: "#",
  resetPassword2: "#",
  resetPassword3: "#",
  resetPasswordSuccess2: "#",
  resetPasswordSuccess3: "#",

  // ui routes (template)
  alert: "#",
  accordion: "#",
  avatar: "#",
  badges: "#",
  border: "#",
  breadcrums: "#",
  button: "#",
  buttonGroup: "#",
  cards: "#",
  carousel: "#",
  colors: "#",
  dropdowns: "#",
  grid: "#",
  images: "#",
  lightbox: "#",
  media: "#",
  modals: "#",
  navTabs: "#",
  offcanvas: "#",
  pagination: "#",
  placeholder: "#",
  popover: "#",
  progress: "#",
  rangeSlider: "#",
  spinner: "#",
  sweetalert: "#",
  toasts: "#",
  tooltip: "#",
  typography: "#",
  video: "#",
  clipboard: "#",
  counter: "#",
  dragandDrop: "#",
  rating: "#",
  ribbon: "#",
  stickyNotes: "#",
  textEditor: "#",
  timeLine: "#",
  scrollBar: "#",
  apexChart: "#",
  primeChart: "#",
  chartJs: "#",
  chart: "#",
  featherIcons: "#",
  falgIcons: "#",
  fontawesome: "#",
  materialIcon: "#",
  pe7icon: "#",
  simpleLineIcon: "#",
  themifyIcon: "#",
  typicon: "#",
  weatherIcon: "#",
  basicInput: "#",
  checkboxandRadion: "#",
  inputGroup: "#",
  gridandGutters: "#",
  formSelect: "#",
  formMask: "#",
  fileUpload: "#",
  horizontalForm: "#",
  formPicker: "#",
  verticalForm: "#",
  floatingLable: "#",
  formValidation: "#",
  reactSelect: "#",
  formWizard: "#",
  iconicIcon: "#",
  sortable: "#",
  swiperjs: "#",
  bootstrapIcons: "#",
  RemixIcons: "#",
  FlagIcons: "#",
  uiAlerts: "#",
  uiAccordion: "#",
  uiAvatar: "#",
  uiBadges: "#",
  uiBorders: "#",
  uiButtons: "#",
  uiButtonsGroup: "#",
  uiBreadcrumb: "#",
  uiCards: "#",
  uiCarousel: "#",
  uiColor: "#",
  uiDropdowns: "#",
  mapLeaflet: "#",

  // settings (template)
  customFields: "#",
  invoiceSettings: "#",
  currencies: "#",
  paymentGateways: "#",
  taxRates: "#",
  schoolSettings: "#",
  religion: "#",
  connectedApps: "#",
  notificationssettings: "#",
  profilesettings: "#",
  securitysettings: "#",
  bussinessSettings: "#",
  seoSettings: "#",
  localizationSettings: "#",
  prefixes: "#",
  preference: "#",
  appearance: "#",
  authenticationSettings: "#",
  aiSettings: "#",
  salarySettings: "#",
  approvalSettings: "#",
  leaveType: "#",
  banIpAddress: "#",
  customCss: "#",
  customJs: "#",
  cronjob: "#",
  Cronjobschedule: "#",
  storage: "#",
  backup: "#",
  clearcache: "#",
  emailSettings: "#",
  emailTemplates: "#",
  gdprCookies: "#",
  smsSettings: "#",
  smsTemplate: "#",
  otpSettings: "#",
  maintenanceMode: "#",
  socialAuthentication: "#",
  companySettings: "#",
  language: "#",
  addLanguage: "#",
  languageWeb: "#",
  localization: "#",

  // content (template)
  countries: "#",
  states: "#",
  cities: "#",
  testimonials: "#",
  faq: "#",
  blogs: "#",
  blogCategories: "#",
  blogComments: "#",
  blogTags: "#",

  // userManagement (template)
  deleteRequest: "#",
  rolesPermissions: "#",
  manageusers: "#",
  permissions: "#",

  // support (template)
  contactMessages: "#",
  tickets: "#",
  ticketGrid: "#",
  ticketList: "#",
  ticketDetails: "#",

  // performance (template)
  performanceIndicator: "#",
  performanceReview: "#",
  performanceAppraisal: "#",
  goalTracking: "#",
  goalType: "#",

  // training (template)
  trainingList: "#",
  trainers: "#",
  trainingType: "#",

  // membership (template)
  membershipplan: "#",
  membershipAddon: "#",
  membershipTransaction: "#",

  // layout (template)
  layoutDefault: "#",
  layoutMini: "#",
  layoutRtl: "#",
  layoutBox: "#",
  layoutDark: "#",
  Horizontal: "#",
  Detached: "#",
  Hovered: "#",
  Boxed: "#",
  Modern: "#",
  TwoColumn: "#",
  HorizontalSingle: "#",
  HorizontalOverlay: "#",
  HorizontalBox: "#",
  MenuAside: "#",
  Transparent: "#",
  WithoutHeader: "#",
  RTL: "#",
  Dark: "#",

  // finance & accounts (template)
  accountsIncome: "#",
  accountsInvoices: "#",
  accountsTransactions: "#",
  expense: "#",
  expenseCategory: "#",
  addInvoice: "#",
  editInvoice: "#",
  categories: "#",
  budgets: "#",
  budgetexpenses: "#",
  budgetrevenues: "#",

  // crm template extras
  clientgrid: "#",
  clientlist: "#",
  clientdetils: "#",
  project: "#",
  projectlist: "#",
  projectdetails: "#",
  tasks: "#",
  tasksdetails: "#",
  taskboard: "#",
  activities: "#",

  // HRM (template)
  employeeList: "#",
  employeeGrid: "#",
  departments: "#",
  designations: "#",
  policy: "#",
  holidays: "#",
  leaveadmin: "#",
  leaveemployee: "#",
  leavesettings: "#",
  attendanceadmin: "#",
  attendanceemployee: "#",
  timesheet: "#",
  scheduletiming: "#",
  overtime: "#",
  promotion: "#",
  resignation: "#",
  termination: "#",

  // recruitment (template)
  jobgrid: "#",
  joblist: "#",
  candidatesGrid: "#",
  candidateslist: "#",
  candidateskanban: "#",
  refferal: "#",

  // finance (template)
  estimate: "#",
  invoices: "#",
  addinvoice: "#",
  editinvoice: "#",
  invoicesdetails: "#",
  payments: "#",
  expenses: "#",
  providentfund: "#",
  taxes: "#",
  invoiceDetails: "#",
  employeesalary: "#",
  payslip: "#",
  payrollAddition: "#",
  payrollOvertime: "#",
  payrollDeduction: "#",

  // administration (template)
  knowledgebase: "#",
  activity: "#",
  users: "#",
  rolePermission: "#",
  permissionpage: "#",
  assetCategories: "#",
  assetList: "#",

  // reports (template)
  expensesreport: "#",
  invoicereport: "#",
  paymentreport: "#",
  projectreport: "#",
  taskreport: "#",
  userreport: "#",
  employeereport: "#",
  employeedetails: "#",
  payslipreport: "#",
  attendancereport: "#",
  leavereport: "#",
  dailyreport: "#",
};
